//ContractorAgreement
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/Concerns.css';
import { generateAgreementCode } from '../../components/GenerateAttendanceCode';

const ContractorAgreement = () => {

  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { agreementId } = useParams();
  const [userId, setUserId] = useState(authState.user._id);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [userName, setUserName] = useState(authState.user.name);

  const mode = agreementId === undefined ? "add" : "update";
  const [agreement, setAgreement] = useState(null);

  const [formErrors, setFormErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [countFormErrors, setCountFormErrors] = useState(0);
  const agreementCode = generateAgreementCode();
  const [formData, setFormData] = useState({
    agreementType: 1,
    userId: userId,
    userCode: userCode,
    userName: userName,
    agreementCode: agreementCode,
    contractorCode: '',
    contractorName: '',
    subContractorCode: '',
    subContractorName: '',
    establishmentCode: '',
    establishmentName: '',
    locationName: '',
    locationAddress: '',
    natureOfWork: '',
    maxContractLabour: 0,
    contractNumber: '',
    agreementDate: null,
    startDate: null,
    startingRemarks: '',
    completionDate: null,
    completionRemarks: '',
    terminationDate: null,
    terminationDetails: '',
    feePaid: 0,
    depositPaid: 0,
    contractorContactPerson: '',
    createdBy: userId,
    isActive: true,
    isDeleted: false,
    remarks: "",
    otherRemarks: '',
    dateCreated: new Date(),
  });

  useEffect(() => {
    document.title = mode === "add" ? "New Agreement" : "Update Agreement";
  }, [mode]);


  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/contractoragreement/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: {agreementId: agreementId}
      };
      // console.log("Getting Data for Update here",config);
      // console.log("Existing formData",formData);

      fetchData(config, { showSuccessToast: false }).then((data) => {
        // console.log("response for update - ",data.agreement);
        // console.log("response ",data.agreement.agreementDate);
        setAgreement(data.agreement);
        setFormData({ 
          agreementType: data.agreement.agreementType,
          userId: data.agreement.userId,
          userCode: data.agreement.userCode,
          userName: data.agreement.userName,
          agreementCode: data.agreement.agreementCode,
          contractorCode: data.agreement.contractorCode,
          contractorName: data.agreement.contractorName,
          subContractorCode: data.agreement.subContractorCode,
          subContractorName: data.agreement.subContractorName,
          establishmentCode: data.agreement.establishmentCode,
          establishmentName: data.agreement.establishmentName,
          locationName: data.agreement.locationName,
          locationAddress: data.agreement.locationAddress,
          natureOfWork: data.agreement.natureOfWork,
          maxContractLabour: data.agreement.maxContractLabour,
          contractNumber: data.agreement.contractNumber,
          agreementDate: data.agreement.agreementDate,
          startDate: data.agreement.startDate,
          startingRemarks: data.agreement.startingRemarks,
          completionDate: data.agreement.completionDate,
          completionRemarks: data.agreement.completionRemarks,
          terminationDate: data.agreement.terminationDate,
          terminationDetails: data.agreement.terminationDetails,
          feePaid: data.agreement.feePaid,
          depositPaid: data.agreement.depositPaid,
          contractorContactPerson: data.agreement.contractorContactPerson,
          createdBy: data.agreement.createdBy,
          isActive: data.agreement.isActive,
          isDeleted: data.agreement.isDeleted,
          otherRemarks: data.agreement.otherRemarks,
          dateCreated: data.agreement.dateCreated,
        });
      });
    }
  }, [mode, authState, agreementId, fetchData]);



  const handleChange = e => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/contractoragreement", 
        method: "post", 
        data: {formData: formData, user: authState.user._id},
        headers: { Authorization: authState.token } 
      };
      fetchData(config).then(() => {
        navigate("/think-contract-contractor-agreement-list");
      });
    }
    else {
      const config = { 
        url: `/contractoragreement/${agreementId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      fetchData(config).then(() => {
        navigate("/think-contract-contractor-agreement-list");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.contractorCode) {
      errors.contractorCode = "Contractor Code is required";
    } else if (formData.contractorCode.length > 14) {
      errors.contractorCode = "Code cannot exceed 14 characters";
    }

    if (!formData.agreementDate) {
      errors.agreementDate = "Agreement Date is required";
    } 

    if (!formData.startDate) {
      errors.startDate = "Agreement Start Date is required";
    } 

    if (isNaN(formData.maxContractLabour)) {
      errors.maxContractLabour = "Max Contract Labour must be a number";
    }

    if (isNaN(formData.feePaid)) {
      errors.feePaid = "Fee Paid must be a number";
    }
    if (isNaN(formData.depositPaid)) {
      errors.depositPaid = "Deposit Paid must be a number";
    }

    if (!formData.natureOfWork) {
      errors.natureOfWork = "Nature of Work is required";
    } else if (formData.natureOfWork.length > 250) {
      errors.natureOfWork = "Nature of Work cannot exceed 250 characters";
    }
    if (!formData.locationName) {
      errors.locationName = "Location Name is required";
    } else if (formData.locationName.length > 100) {
      errors.locationName = "Location Name cannot exceed 100 characters";
    }

    if (!formData.contractNumber) {
      errors.contractNumber = "Contract Number is required";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const handleCancelClick = () => {
    navigate(-1);
  };

  return (
    <>
      <MainLayout>
        <div className="min-h-full py-8 bg-gradient-to-r from-gray-600 via-gray-700 to-gray-800 mt-12 rounded-lg">
          <h3 className='text-2xl font-bold text-white text-center mb-6'>Contractor-Principal Employer Agreement</h3>
          {loading ? (
            <Loader />
          ) : (
            <div className='text-m'>
              <div className='flex justify-center'>
                <h2 className="ml-2 text-xl text-yellow-200">{mode === "add" ? "Add New Agreement" : "Edit Agreement"}</h2>
              </div>
              <div className="border-container">
                  <div className="mb-4">
                      <p className="text-yellow-300">Your Auto Agreement Code: {agreementCode}</p>
                  </div>
              </div>
              <div className="border-container flex flex-col text-white text-sm">
                <p>Contractor Code*:</p>
                <input
                  type="text"
                  className="profile-input text-black py-2 px-4 "
                  style={{ width: '200px'}}
                  value={formData.contractorCode}
                  onChange={(e) => setFormData({ ...formData, contractorCode: e.target.value })}
                  placeholder="Input Code here"
                />
                {fieldError("contractorCode")}
                <p>Contractor Name*:</p>
                <input
                  type="text"
                  className="profile-input text-black py-2 px-4 "
                  style={{ width: '500px'}}
                  value={formData.contractorName}
                  onChange={(e) => setFormData({ ...formData, contractorName: e.target.value })}
                  placeholder="Input Name here"
                />
                {fieldError("contractorName")}
                
                <p>Establishment /Principal Employer Code*:</p>
                <input
                  type="text"
                  className="profile-input text-black py-2 px-4 "
                  style={{ width: '200px'}}
                  value={formData.establishmentCode}
                  onChange={(e) => setFormData({ ...formData, establishmentCode: e.target.value })}
                  placeholder="Input Code here"
                />
                {fieldError("establishmentCode")}

                <p>Establishment /Principal Employer Name*:</p>
                <input
                  type="text"
                  className="profile-input text-black py-2 px-4 "
                  style={{ width: '500px'}}
                  value={formData.establishmentName}
                  onChange={(e) => setFormData({ ...formData, establishmentName: e.target.value })}
                  placeholder="Input Name here"
                />
                {fieldError("establishmentName")}
              </div>
              <div className="border-container text-sm">
                <p className='text-white'>Location Name*:</p>
                <input 
                  type="text" 
                  name="locationName" 
                  id="locationName" 
                  value={formData.locationName} 
                  placeholder="Enter Location Name..."
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '75%' }} 
                />
                {fieldError("locationName")}
                <p className='text-white'>Location Address*:</p>
                <textarea 
                  type="text" 
                  name="locationAddress" 
                  id="locationAddress" 
                  value={formData.locationAddress}
                  onChange={handleChange}
                  maxLength="500"
                  style={{
                    border: '1px solid #ccc',
                    padding: '2px',
                    backgroundColor: '#f0f0f0', 
                    color: '#000000',
                    width: '100%', 
                    height: '100px' 
                  }}
                />
                {fieldError("locationAddress")}
                <p className='text-white'>Nature of Work*:</p>
                <input 
                  type="text" 
                  name="natureOfWork" 
                  id="natureOfWork" 
                  value={formData.natureOfWork} 
                  placeholder="Enter Nature of Work...."
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '75%' }} 
                />
                {fieldError("natureOfWork")}
                <p className='text-white'>Max Contract Laboures*:</p>
                <input 
                  type="text" 
                  name="maxContractLabour" 
                  id="maxContractLabour" 
                  value={formData.maxContractLabour} 
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                />
                {fieldError("maxContractLabour")}
                <p className='text-white'>Deposit Paid:</p>
                <input 
                  type="text" 
                  name="depositPaid" 
                  id="depositPaid" 
                  value={formData.depositPaid} 
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                />
                {fieldError("depositPaid")}

                <p className='text-white'>Fee Paid:</p>
                <input 
                  type="text" 
                  name="feePaid" 
                  id="feePaid" 
                  value={formData.feePaid} 
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                />
                {fieldError("feePaid")}

                <p className='text-white'>Contractor's Contact Person*:</p>
                <input 
                  type="text" 
                  name="contractorContactPerson" 
                  id="contractorContactPerson" 
                  value={formData.contractorContactPerson} 
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '500px' }} 
                />
                {fieldError("contractorContactPerson")}
              </div>

              <div className="border-container text-sm">
                <p className='text-white'>Agreement / Contract Number:</p>
                  <input 
                    type="text" 
                    name="contractNumber" 
                    id="contractNumber" 
                    value={formData.contractNumber} 
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '500px' }} 
                  />
                  {fieldError("contractNumber")}
                  <p className='text-white'>Agreement Date*:</p>
                  <input 
                    type="date" 
                    name="agreementDate" 
                    id="agreementDate" 
                    value={formData.agreementDate} 
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                  />
                  {fieldError("agreementDate")}
                  <p className='text-white'>Start Date*:</p>
                  <input 
                    type="date" 
                    name="startDate" 
                    id="startDate" 
                    value={formData.startDate} 
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                  />
                  {fieldError("startDate")}
                  <p className='text-white'>Starting Remarks:</p>
                  <textarea 
                    type="text" 
                    name="startingRemarks" 
                    id="startingRemarks" 
                    value={formData.startingRemarks}
                    onChange={handleChange}
                    maxLength="2500"
                    style={{
                      border: '1px solid #ccc',
                      padding: '2px',
                      backgroundColor: '#f0f0f0', 
                      color: '#000000',
                      width: '100%', 
                      height: '100px' 
                    }}
                  />
                  {fieldError("startingRemarks")}
              </div>

              <div className="border-container text-sm">
                  <p className='text-white'>Completion Date*:</p>
                  <input 
                    type="date" 
                    name="completionDate" 
                    id="completionDate" 
                    value={formData.completionDate} 
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                  />
                  {fieldError("completionDate")}
                  <p className='text-white'>Completion Remarks:</p>
                  <textarea 
                    type="text" 
                    name="completionRemarks" 
                    id="completionRemarks" 
                    value={formData.completionRemarks}
                    onChange={handleChange}
                    maxLength="2500"
                    style={{
                      border: '1px solid #ccc',
                      padding: '2px',
                      backgroundColor: '#f0f0f0', 
                      color: '#000000',
                      width: '100%', 
                      height: '100px' 
                    }}
                  />
                  {fieldError("completionRemarks")}
              </div>

              <div className="border-container text-sm">
                  <p className='text-white'>Termination Date:</p>
                  <input 
                    type="date" 
                    name="terminationDate" 
                    id="completterminationDateionDate" 
                    value={formData.terminationDate} 
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                  />
                  {fieldError("terminationDate")}
                  <p className='text-white'>Termination Remarks:</p>
                  <textarea 
                    type="text" 
                    name="terminationDetails" 
                    id="terminationDetails" 
                    value={formData.terminationDetails}
                    onChange={handleChange}
                    maxLength="2500"
                    style={{
                      border: '1px solid #ccc',
                      padding: '2px',
                      backgroundColor: '#f0f0f0', 
                      color: '#000000',
                      width: '100%', 
                      height: '100px' 
                    }}
                  />
                  {fieldError("terminationDetails")}
              </div>

            <div className="border-container text-sm">
              <p className='text-white'>Other Remarks:</p>
              <textarea 
                name="otherRemarks" 
                id="otherRemarks" 
                value={formData.otherRemarks} 
                onChange={handleChange}
                maxLength="2500"
                style={{
                  border: '1px solid #ccc',
                  padding: '2px',
                  backgroundColor: '#f0f0f0', 
                  color: '#000000',
                  width: '100%', 
                  height: '100px' 
                }} 
              />
              {fieldError("otherRemarks")}
            </div>
            <div className="border-container flex flex-col justify-center">
              <div className="flex justify-center">
                {Object.keys(formErrors).length > 0 && (
                  <div className="form-errors text-red-300 justify-center items-center">
                    {Object.keys(formErrors).map((key) => (
                      <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                    ))}
                  </div>
                )}
              </div>
              <div className="flex justify-center">
                <button className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' onClick={handleSubmit}>{mode === "add" ? "Add New" : "Update"}</button>
                <button className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' onClick={() => navigate("/think-contract-contractor-agreement-list")}>Cancel</button>
              </div>
          </div>  
          </div>
          )}
        </div>
      </MainLayout>
    </>
  )
}

export default ContractorAgreement